export enum LiveOrder {
  Join = 'join',
  Progress = 'progress',
  Pace = 'pace',
  IntervalPace = 'interval_pace',
  IntervalProgress = 'interval_progress',
}

export enum LiveViewMode {
  Tiles = 'tiles',
  Rows = 'rows',
  Aggregated = 'aggregated',
}

export enum TeamDisplayMode {
  OnlyAthletes = 'only_athletes',
  OnlyTeams = 'only_teams',
  AthletesAndTeams = 'athletes_and_teams',
  TeamsAndAthletesWithoutTeams = 'teams_and_athletes_without_teams',
}
